@file:Suppress("REDUNDANT_VISIBILITY_MODIFIER")

package com.macrofocus.eflux

import kotlin.String
import kotlin.Suppress

internal object BuildKonfig {
  public val efluxVersion: String = "3.0.1"
}
